import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/3d-model.png'
import _imports_1 from '../../assets/images/three-dimensional.png'


const _withScopeId = n => (_pushScopeId("data-v-408955fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-analysis-container" }
const _hoisted_2 = {
  ref: "modalContent",
  class: "bowx-modal"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "w-full pl-5 text-center text-xl md:text-3xl font-bold" }, "모델 자동분석 결과", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-cross" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "bowx-content" }
const _hoisted_7 = { class: "bowx-left p-3" }
const _hoisted_8 = { class: "flex items-start" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-3dmodel",
  src: _imports_0
}, null, -1))
const _hoisted_10 = { class: "text-lg font-bold" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full mt-2 mb-3 border-b" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-4" }, [
  /*#__PURE__*/_createTextVNode(" 견적을 문의하시면 전문가가"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("상세검토 후 연락드리겠습니다. ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, null, -1))
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "ml-3 text-sm" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-rr-eye" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-rr-eye" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "mt-2 mb-2 border-b border-line"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "ml-3 text-sm" }
const _hoisted_28 = { class: "bowx-commands text-2xs md:text-xs" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { class: "mr-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bowx-solid" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "w-full text-center text-desc",
  style: {"margin-top":"0.3rem"}
}, "면", -1))
const _hoisted_34 = { class: "mr-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bowx-opacity" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "w-full text-center text-desc break-keep",
  style: {"margin-top":"0.3rem"}
}, " 반투명 ", -1))
const _hoisted_38 = { class: "mr-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bowx-wire" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "w-full text-center text-desc",
  style: {"margin-top":"0.3rem"}
}, "선", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-5 ml-5 mr-6 border-l border-line2" }, null, -1))
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-divde mr-2",
  src: _imports_1
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-2 border-b border-line2" }, null, -1))
const _hoisted_46 = { class: "flex items-center justify-between" }
const _hoisted_47 = { class: "text-desc font-semibold" }
const _hoisted_48 = { class: "text-desc font-semibold" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_50 = {
  key: 1,
  class: "items-center justify-center bounding-loader rounded-md"
}
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"loader-boxs\" data-v-408955fc><div class=\"scene\" data-v-408955fc><div class=\"plane\" data-v-408955fc><div class=\"cube cube--0\" data-v-408955fc><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div></div><div class=\"shadow shadow--0\" data-v-408955fc></div><div class=\"cube cube--1\" data-v-408955fc><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div></div><div class=\"shadow shadow--1\" data-v-408955fc></div><div class=\"cube cube--2\" data-v-408955fc><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div></div><div class=\"shadow shadow--2\" data-v-408955fc></div><div class=\"cube cube--3\" data-v-408955fc><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div></div><div class=\"shadow shadow--3\" data-v-408955fc></div><div class=\"cube cube--4\" data-v-408955fc><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div></div><div class=\"shadow shadow--4\" data-v-408955fc></div><div class=\"cube cube--5\" data-v-408955fc><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div></div><div class=\"shadow shadow--5\" data-v-408955fc></div><div class=\"cube cube--6\" data-v-408955fc><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div></div><div class=\"shadow shadow--6\" data-v-408955fc></div><div class=\"cube cube--7\" data-v-408955fc><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div><div class=\"cube__side\" data-v-408955fc></div></div><div class=\"shadow shadow--7\" data-v-408955fc></div></div></div></div>", 1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  class: "bowx-left-small overflow-auto p-3",
  style: {"height":"calc(100vh - 365px)"}
}
const _hoisted_54 = { class: "flex items-start" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-3dmodel",
  src: _imports_0
}, null, -1))
const _hoisted_56 = { class: "text-md md:text-lg font-bold" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full mt-2 mb-3 border-b" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-sm leading-4" }, [
  /*#__PURE__*/_createTextVNode(" 견적을 문의하시면 전문가가"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("상세검토 후 연락드리겠습니다. ")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, null, -1))
const _hoisted_60 = { class: "mt-2" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "flex items-center" }
const _hoisted_63 = { class: "ml-3 text-xs md:text-sm" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-rr-eye" }, null, -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-rr-eye" }, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = {
  key: 0,
  class: "mt-2 mb-2 border-b border-line"
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "flex items-center" }
const _hoisted_73 = { class: "ml-3 text-xs md:text-sm" }

import {ModelStore} from "../../store/model-store";
import {CommonStore} from "../../store/common-store";
import {cfgCommon} from "../../views/components/3d/ctxConfig"; // 초기 설정 정보 가져오기
import {OptionsStore} from "../../store/options-store";
import {Model3D, Model3DAnalysis} from "../../js/interface";
import {AnalysisStatus, AnalysisStatusKo, Modals} from "../../js/types";
import {numberToComma} from "../../js/utils";

import ModalInstructions from "./modal-instructions.vue";


import {ref, computed, defineComponent, watch, onMounted} from "vue";
import {storeToRefs} from "pinia";
import axios from "axios";

import Slider from "vue3-slider";
import CtxSTLViewer from "../components/3d/ctxSTLViewer.vue";

const __default__ = defineComponent({
  name: "ModalAnalysis",
  components: {CtxSTLViewer, Slider},
  methods: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  model: {
    type: Object,
    default: null,
  },
},
  emits: ["onClose"],
  setup(__props, { emit }) {

const props = __props;

const {
  isDownloadModel,
  isThicknessView,
  isGapView,
  isMulitBodyView,
  textuerStatus,
  clipingValue,
  clipingMaxValue,
} = storeToRefs(CommonStore());

// [Props] -----------------------------------------------------------------------




// CtxSTLViewer용 Props
const wireframeColor = ref(cfgCommon.viewer.wireframeColor); // #D8D8D8
const faceColor = ref(cfgCommon.viewer.faceColor); // #BABABA
const modelPosition = cfgCommon.model.pos; // new Vector3(0, 0, 0)
const modelScale = cfgCommon.model.scale; // 1
const cameraPosition = cfgCommon.camera.pos; // new Vector3(20, 20, 20)

const fileName = ref("");
const analysis = ref();
const analysisRaw = ref();
const s3Paths = ref([] as any);

const rightContent = ref();

const analysisTypes = ref([
  "loadFile",
  "normalSize",
  "buildSize",
  "checkModel",
  "overVolume",
  "waterproof",
  "multiBody",
  "thickness",
  "gap",
  "hollow",
]);

const cptAnalysis = computed(() => {
  switch (props.model.modelAnalysis) {
    case AnalysisStatus.Fail:
      return AnalysisStatusKo.Fail;
    case AnalysisStatus.Warn:
      return AnalysisStatusKo.Warn;
    case AnalysisStatus.Caution:
      return AnalysisStatusKo.Caution;
    default:
      return AnalysisStatusKo.Pass;
  }
});
const cptThickness = computed(() => {
  if (analysisRaw.value && analysisRaw.value[7]) {
    return analysisRaw.value[7].value;
  } else {
    return [];
  }
});
const cptGap = computed(() => {
  if (analysisRaw.value && analysisRaw.value[8]) {
    return analysisRaw.value[8].value;
  } else {
    return [];
  }
});
const cptBuildMaxSize = computed(() => {
  if (!props.model.id) {
    return {};
  }

  const company: any = OptionsStore().getCompanyById(props.model.modelCompanyId);
  return {x: company.buildX, y: company.buildY, z: company.buildZ};
});
const cptManifWarn = computed(() => {
  if (analysis.value && analysis.value[5]) {
    return analysis.value[5].value;
  } else {
    return [];
  }
});
const cptProblemAnalysis = computed(() => {
  const list = props.model.analysis.filter((val: Model3DAnalysis) => {
    if (
      AnalysisStatus.Fail === val.status ||
      AnalysisStatus.Warn === val.status ||
      AnalysisStatus.Caution === val.status
    ) {
      return val;
    }
  });

  return list;
});
const cptIsFailed = computed(() => {
  if (props.model && props.model.analysisRaw) {
    if (AnalysisStatus.Fail === props.model.analysisRaw.analysis[0].status) {
      return false;
    }
    // if (AnalysisStatus.Fail === props.model.analysisRaw[1].status) {
    //   return false;
    // }
    // if (AnalysisStatus.Fail === props.model.analysisRaw[2].status) {
    //   return false;
    // }
  }

  return true;
});

onMounted(async () => {
  CommonStore().setTextuerStatus(0);
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  isDownloadModel.value = false;

  analysis.value = props.model.analysis;
  fileName.value = props.model.name;

  // signed Url 방식 적용
  let key = props.model.modelKey;
  if (fileName.value) {
    const ext = fileName.value.slice(fileName.value.lastIndexOf(".") + 1).toLowerCase();
    if ("stp" === ext || "STP" === ext || "step" === ext || "STEP" === ext) {
      key = key + ".stp.stl";
    }
  }

  const resAnalysis = await axios.get(`/models/${props.model.id}/analysis`, {
    params: {
      processId: props.model.modelProcessId,
    },
  });
  analysisRaw.value = resAnalysis.data.result.analysisRaw;

  const paths = [] as any;
  const resPath = await axios.post(`/models/${props.model.id}`, {
    key: key,
  });
  paths.push(resPath.data.result.signedUrl);
  s3Paths.value = paths;
});

const onClose = () => {
  ModelStore().setCurrentModel({} as Model3D);
};
const onSolid = () => {
  CommonStore().setTextuerStatus(0);
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(false);
};
const onOpacity = () => {
  CommonStore().setTextuerStatus(1);
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(false);
};
const onWire = () => {
  CommonStore().setTextuerStatus(2);
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(false);
};
const onSliderChange = (value: number) => {
  CommonStore().setClipingValue(value);
};
const onInst = (type: string) => {
  CommonStore().showModal(ModalInstructions, type);
};
const onThickness = () => {
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(false);
  CommonStore().setIsThicknessView(!isThicknessView.value);

  if (isThicknessView.value) {
    CommonStore().setTextuerStatus(2);
  } else {
    CommonStore().setTextuerStatus(0);
  }
};
const onGap = () => {
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsMulitBodyView(false);
  CommonStore().setIsGapView(!isGapView.value);

  if (isGapView.value) {
    CommonStore().setTextuerStatus(2);
  } else {
    CommonStore().setTextuerStatus(0);
  }
};
const onMulitBody = () => {
  CommonStore().setIsThicknessView(false);
  CommonStore().setIsGapView(false);
  CommonStore().setIsMulitBodyView(!isMulitBodyView.value);

  if (isMulitBodyView.value) {
    CommonStore().setTextuerStatus(3);
  } else {
    CommonStore().setTextuerStatus(0);
  }
};

const convertTypeToKR = (type: string) => {
  if ("loadFile" === type) {
    return "파일 확장자 검사";
  } else if ("normalSize" === type) {
    return "정상모델 크기 검사";
  } else if ("buildSize" === type) {
    return "생산가능 크기 검사";
  } else if ("checkModel" === type) {
    return "파일 손상 검사";
  } else if ("overVolume" === type) {
    return "재료 소모량 검사";
  } else if ("multiBody" === type) {
    return "다중 모델 검사";
  } else if ("thickness" === type) {
    return "최소 두께 검사";
  } else if ("gap" === type) {
    return "단차 검사(양각/음각)";
  } else if ("hollow" === type) {
    return "갇힌 공간 검사";
  } else if ("waterproof" === type) {
    return "솔리드 구조 검사";
  }
};
const convertStatusToKR = (status: string) => {
  switch (status) {
    case AnalysisStatus.Fail:
      return AnalysisStatusKo.Fail;
    case AnalysisStatus.Warn:
      return AnalysisStatusKo.Warn;
    case AnalysisStatus.Caution:
      return AnalysisStatusKo.Caution;
    case AnalysisStatus.Stop:
      return AnalysisStatusKo.Stop;
    default:
      return AnalysisStatusKo.Pass;
  }
};
const classAnalysis = (status: string) => {
  switch (status) {
    case AnalysisStatus.Fail:
      return "cs-badge-disabled";
    case AnalysisStatus.Stop:
      return "cs-badge-stop";
    case AnalysisStatus.Warn:
      return "cs-badge-warn";
    case AnalysisStatus.Caution:
      return "cs-badge-caution";
    default:
      return "cs-badge-pass";
  }
};
const analysisByType = (type: string) => {
  for (let i = 0; i < props.model.analysis.length; i++) {
    if (type === props.model.analysis[i].type) {
      return props.model.analysis[i];
    }
  }

  return {type: type, status: AnalysisStatus.Stop};
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", { class: "flex items-center justify-between h-16 px-8 border-b border-line" }, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createElementVNode("button", { onClick: onClose }, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", {
              class: _normalizeClass(["w-full mt-1 ml-1 px-3 py-3 rounded-md", [classAnalysis(props.model.modelAnalysis)]])
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(cptAnalysis.value), 1),
              _hoisted_11,
              _hoisted_12
            ], 2)
          ]),
          _hoisted_13,
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisTypes.value, (analType) => {
              return (_openBlock(), _createElementBlock("div", { key: analType }, [
                ('pass' != analysisByType(analType).status)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: ($event: any) => (onInst(analysisByType(analType).type)),
                      class: "bowx-analysis flex overflow-hidden justify-between items-center mt-1 p-1 border border-line rounded-md bg-white cursor-pointer hover:border-slate-400"
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["px-3 py-2 rounded-l text-md font-semibold", [classAnalysis(analysisByType(analType).status)]])
                        }, _toDisplayString(convertStatusToKR(analysisByType(analType).status)), 3),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(convertTypeToKR(analysisByType(analType).type)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        ('thickness' === analysisByType(analType).type)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["bowx-info mr-2", [{active: _unref(isThicknessView)}]]),
                              onClick: _withModifiers(onThickness, ["stop"])
                            }, _hoisted_20, 10, _hoisted_18))
                          : _createCommentVNode("", true),
                        ('gap' === analysisByType(analType).type)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: _normalizeClass(["bowx-info mr-2", [{active: _unref(isGapView)}]]),
                              onClick: _withModifiers(onGap, ["stop"])
                            }, _hoisted_23, 10, _hoisted_21))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (cptProblemAnalysis.value && cptProblemAnalysis.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24))
            : _createCommentVNode("", true),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisTypes.value, (analType) => {
              return (_openBlock(), _createElementBlock("div", { key: analType }, [
                ('pass' === analysisByType(analType).status)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: ($event: any) => (onInst(analysisByType(analType).type)),
                      class: "bowx-analysis flex overflow-hidden justify-between items-center mt-1 p-1 border border-line rounded-md bg-white cursor-pointer hover:border-slate-400"
                    }, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["px-3 py-2 rounded-l text-md font-semibold", [classAnalysis(analysisByType(analType).status)]])
                        }, _toDisplayString(convertStatusToKR(analysisByType(analType).status)), 3),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(convertTypeToKR(analysisByType(analType).type)), 1)
                      ])
                    ], 8, _hoisted_25))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          ref_key: "rightContent",
          ref: rightContent,
          class: "bowx-right"
        }, [
          (0 < s3Paths.value.length && cptIsFailed.value)
            ? (_openBlock(), _createBlock(CtxSTLViewer, {
                key: 0,
                objPaths: s3Paths.value,
                wireframeColor: wireframeColor.value,
                faceColor: faceColor.value,
                defaultModelPosition: _unref(modelPosition),
                defaultModelScale: _unref(modelScale),
                defaultCameraPosition: _unref(cameraPosition),
                frame: {w: rightContent.value.clientWidth, h: rightContent.value.clientHeight},
                analysis: analysis.value,
                analysisRaw: analysisRaw.value,
                buildMaxSize: cptBuildMaxSize.value,
                manifold: [],
                thickness: cptThickness.value,
                gap: cptGap.value
              }, null, 8, ["objPaths", "wireframeColor", "faceColor", "defaultModelPosition", "defaultModelScale", "defaultCameraPosition", "frame", "analysis", "analysisRaw", "buildMaxSize", "thickness", "gap"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: _normalizeClass(["bowx-command-btn", [{active: 0 === _unref(textuerStatus)}]]),
                  onClick: onSolid
                }, _hoisted_32, 2),
                _hoisted_33
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  class: _normalizeClass(["bowx-command-btn", [{active: 1 === _unref(textuerStatus)}]]),
                  onClick: onOpacity
                }, _hoisted_36, 2),
                _hoisted_37
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  class: _normalizeClass(["bowx-command-btn", [{active: 2 === _unref(textuerStatus)}]]),
                  onClick: onWire
                }, _hoisted_40, 2),
                _hoisted_41
              ]),
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_unref(Slider), {
                  modelValue: _unref(clipingValue),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(clipingValue) ? (clipingValue).value = $event : null)),
                  width: "100px",
                  color: "#666",
                  "track-color": "#FFF",
                  alwaysShowHandle: true,
                  handleScale: 1.8,
                  min: 0.01,
                  max: _unref(clipingMaxValue),
                  step: 0.1,
                  onChange: onSliderChange
                }, null, 8, ["modelValue", "max"])
              ])
            ]),
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, " 크기: " + _toDisplayString(parseFloat(props.model.modelSizeX.toFixed(2))) + " x " + _toDisplayString(parseFloat(props.model.modelSizeY.toFixed(2))) + " x " + _toDisplayString(parseFloat(props.model.modelSizeZ.toFixed(2))) + _toDisplayString(props.model.modelUnit), 1),
              _createElementVNode("div", _hoisted_48, [
                _createTextVNode(" 부피: " + _toDisplayString(_unref(numberToComma)(props.model.modelVolume)) + "㎜", 1),
                _hoisted_49
              ])
            ])
          ]),
          (!_unref(isDownloadModel) && cptIsFailed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
            : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("div", {
              class: _normalizeClass(["w-full mt-1 ml-1 px-3 py-3 rounded-md", [classAnalysis(props.model.modelAnalysis)]])
            }, [
              _createElementVNode("div", _hoisted_56, _toDisplayString(cptAnalysis.value), 1),
              _hoisted_57,
              _hoisted_58
            ], 2)
          ]),
          _hoisted_59,
          _createElementVNode("ul", _hoisted_60, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisTypes.value, (analType) => {
              return (_openBlock(), _createElementBlock("div", { key: analType }, [
                ('pass' != analysisByType(analType).status)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: ($event: any) => (onInst(analysisByType(analType).type)),
                      class: "bowx-analysis flex overflow-hidden justify-between items-center mt-1 p-1 border border-line rounded-md bg-white"
                    }, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["px-3 py-2 rounded-l text-sm md:text-md font-semibold", [classAnalysis(analysisByType(analType).status)]])
                        }, _toDisplayString(convertStatusToKR(analysisByType(analType).status)), 3),
                        _createElementVNode("div", _hoisted_63, _toDisplayString(convertTypeToKR(analysisByType(analType).type)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        ('thickness' === analysisByType(analType).type)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "bowx-info mr-2",
                              onClick: _withModifiers(onThickness, ["stop"])
                            }, _hoisted_66, 8, _hoisted_64))
                          : _createCommentVNode("", true),
                        ('gap' === analysisByType(analType).type)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "bowx-info mr-2",
                              onClick: _withModifiers(onGap, ["stop"])
                            }, _hoisted_69, 8, _hoisted_67))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_61))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (cptProblemAnalysis.value && cptProblemAnalysis.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70))
            : _createCommentVNode("", true),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisTypes.value, (analType) => {
              return (_openBlock(), _createElementBlock("div", { key: analType }, [
                ('pass' === analysisByType(analType).status)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: ($event: any) => (onInst(analysisByType(analType).type)),
                      class: "bowx-analysis flex overflow-hidden justify-between items-center mt-1 p-1 border border-line rounded-md bg-white"
                    }, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["px-3 py-2 rounded-l text-sm md:text-md font-semibold", [classAnalysis(analysisByType(analType).status)]])
                        }, _toDisplayString(convertStatusToKR(analysisByType(analType).status)), 3),
                        _createElementVNode("div", _hoisted_73, _toDisplayString(convertTypeToKR(analysisByType(analType).type)), 1)
                      ])
                    ], 8, _hoisted_71))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})